import type { AccessPolicyDto } from '@data-access/connect/tc-ecom';

export const CUSTOM_PROPERTIES_PROP3D_FEATURE = '3D_MODEL_PROPERTY';

export const CUSTOM_PROPERTIES_MUTATION_ACTIONS = [
  '3dproperty:Create',
  '3dproperty:Update',
] as const;

/**
 * @intent Commerce gate for custom property mutations (add/edit/delete UI).
 * Uses EMS access-policy (tcweb/CDM parity). Viewing/listing is not gated.
 */
export function isCustomPropertiesMutationAllowed(
  accessPolicy: AccessPolicyDto | undefined
): boolean {
  if (accessPolicy?.appAccess !== true) {
    return false;
  }

  const prop3dFeature = accessPolicy?.features?.find(
    (feature) => feature.feature === CUSTOM_PROPERTIES_PROP3D_FEATURE
  );

  if (prop3dFeature === undefined) {
    return false;
  }

  return CUSTOM_PROPERTIES_MUTATION_ACTIONS.every((action) =>
    prop3dFeature.allowedActions.includes(action)
  );
}
